export default __webpack_public_path__ + "static/media/recommendation_filter.af64d45f.svg";